package org.gymly.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImage

/** Logo del gimnasio en círculo. El tamaño lo marca `size` en cada encabezado. */
@Composable
fun BrandLogo(
    logoUrl: String?,
    name: String,
    modifier: Modifier = Modifier,
    height: Dp = 40.dp,
    fallback: @Composable () -> Unit,
) {
    if (logoUrl.isNullOrBlank()) {
        fallback()
        return
    }
    Box(
        modifier
            .size(height)
            .graphicsLayer {
                clip = true
                shape = CircleShape
            }
            .clip(CircleShape)
            .background(Color.White, CircleShape),
        contentAlignment = Alignment.Center,
    ) {
        AsyncImage(
            model = logoUrl,
            contentDescription = name,
            modifier = Modifier
                .fillMaxSize()
                .graphicsLayer {
                    clip = true
                    shape = CircleShape
                }
                .clip(CircleShape),
            contentScale = ContentScale.Crop,
        )
    }
}
